import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=3e57ee09&scoped=true"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js"
import style0 from "./SettingsGeneral.vue?vue&type=style&index=0&id=3e57ee09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57ee09",
  null
  
)

export default component.exports